import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
// import '../styling/styles.scss';

function SuccessModal(props) {
    return (
        <Modal
            {...props}
            centered
            className="modal_container"
        >
            <Modal.Body>
                <div className="modal_container">
                    <div className="modal_Card">
                            <h3>{props.status}</h3>
                            <p>{props.message}</p>
                            <button  onClick={() => props.hide()}>Ok</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export default SuccessModal;
